import { render } from "./transport-list-remote.vue?vue&type=template&id=6c176499"
import script from "./transport-list-remote.vue?vue&type=script&lang=js"
export * from "./transport-list-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__